import {
  PARENT_ACCOUNT_CONTACTS_SECTION,
  PARENT_ACCOUNT_SECTION_PARAM,
  PARENT_HOME_ROUTE,
  PARENT_LOGIN_ROUTE,
  PARENT_PLAYER_ROUTE,
  PARENT_REPORT_CARD_ROUTE,
} from '../../../_configuration';
import { NEXT_PARAM, loginPathWithNext, readNextPath } from './next-path.helpers';

// Player-profile path for a logged-in parent (no URL token). The PARENT JWT
// rides on the Apollo client and the server's ACL accepts it via
// PlayerContact.parentId ownership. Anonymous email-link callers reach the
// same route with a `?token=` query param appended by the server's email
// builder — this helper is only used from already-authenticated parent UI.
export const parentPlayerPath = (code: string, playerAssessmentId: string) =>
  `${PARENT_PLAYER_ROUTE}/${code}/${playerAssessmentId}`;

// Same shape as parentPlayerPath, but keeps the token argument: report-card
// shareable links are still generated for anonymous (non-parent) recipients.
// Token is appended only when supplied — authenticated parent UI passes none.
export const parentReportCardPath = (code: string, playerAssessmentId: string, token?: string) => {
  const base = `${PARENT_REPORT_CARD_ROUTE}/${code}/${playerAssessmentId}`;
  return token ? `${base}?token=${encodeURIComponent(token)}` : base;
};

export const PARENT_NEXT_PARAM = NEXT_PARAM;

// Login URL that remembers where the parent was headed. Email/SMS deep links
// land on a gated route first, so the destination has to survive the bounce.
export const parentLoginPathWithNext = (pathname: string, search?: string) =>
  loginPathWithNext(PARENT_LOGIN_ROUTE, pathname, search);

// Only same-origin paths inside the parent tree are honored; the guards (and why
// each one is there) live in `next-path.helpers.ts`.
export const readParentNextPath = (search: string): string | null =>
  readNextPath(search, { loginRoute: PARENT_LOGIN_ROUTE, requirePrefix: `${PARENT_HOME_ROUTE}/` });

// Where a signed-in parent goes from the login page: the deep link they were headed to, else My Players.
export const parentPostLoginPath = (search: string): string => readParentNextPath(search) || PARENT_HOME_ROUTE;

// True when a deep link asked for the account page's contacts section — the
// welcome email and intro SMS both land here with the expander pre-opened.
export const isParentContactsSection = (search: string) =>
  new URLSearchParams(search).get(PARENT_ACCOUNT_SECTION_PARAM) === PARENT_ACCOUNT_CONTACTS_SECTION;
